import { Loader2, X } from "lucide-react";
import React from "react";

import { StatusBadge } from "@/components/ui";
import type { FacilitatorStatus } from "@/hooks/useMarketplaceFacilitators";

interface FacilitatorChipProps {
  row: FacilitatorStatus;
  busy: boolean;
  removeRef: (el: HTMLButtonElement | null) => void;
  onRemove: () => void;
}

export const FacilitatorChip: React.FC<FacilitatorChipProps> = ({
  row,
  busy,
  removeRef,
  onRemove,
}) => (
  <StatusBadge status="ACTIVE" className="pr-1">
    {row.marketplaceName}
    <button
      ref={removeRef}
      type="button"
      aria-label={`Remove as ${row.marketplaceName} facilitator`}
      aria-busy={busy}
      disabled={busy}
      onClick={onRemove}
      className="relative ml-0.5 inline-flex h-4 w-4 items-center justify-center rounded-full text-emerald-600 transition-[color,background-color,transform] duration-150 ease-out hover:bg-emerald-100 hover:text-emerald-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 disabled:opacity-60 motion-safe:active:scale-90 dark:text-emerald-400 dark:hover:bg-emerald-900 dark:hover:text-emerald-200 after:absolute after:-inset-1 after:rounded-full after:content-['']"
    >
      {busy ? (
        <Loader2 className="h-3 w-3 motion-safe:animate-spin" aria-hidden />
      ) : (
        <X className="h-3 w-3" aria-hidden />
      )}
    </button>
  </StatusBadge>
);
